import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactoHero from "./sections/ContactoHero";
import FormularioDeContacto from "./sections/FormularioDeContacto";
import UbicacionesYMapa from "./sections/UbicacionesYMapa";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactoHero />
      <FormularioDeContacto />
      <UbicacionesYMapa />
      <Footer />
    </div>;
}